import React from "react";
import { motion, useViewportScroll, useTransform } from "framer-motion";
import skills from "../Data/Skills/Skills";

function Skills() {
  const { scrollY } = useViewportScroll();
  const opacity = useTransform(scrollY, [0, 200], [1, 0]);
  const scale = useTransform(scrollY, [0, 200], [1, 0.8]);
  const rotate = useTransform(scrollY, [0, 200], [0, 360]);
  const y = useTransform(scrollY, [0, 200], [0, -50]);

  return (
    <motion.div>
      <motion.h2 style={{ opacity }}>Skills</motion.h2>
      <motion.div style={{ scale, rotate, y }}>
        <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.5, duration: 1.5 }} 
            className="grid grid-cols-2 md:grid-cols-4 gap-8"
          >
            {skills.map((skill, index) => (
              <motion.div
                key={index}
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: index * 0.1 + 0.5, duration: 2.5 }} 
                className="bg-white rounded-lg shadow-md overflow-hidden border-2 border-lime-500"
              >
                <img
                  src={skill.image}
                  alt="skill"
                  className="w-full h-32 object-cover"
                />
                <div className="px-4 py-2 border-t-2 border-lime-500">
                  <h3 className="text-lg font-bold mb-2">{skill.name}</h3>
                  <p className="text-gray-600 text-sm">{skill.level} Level</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </motion.div>
    </motion.div>
  );
}

export default Skills;